<template>
  <div
    class="dish-image"
    :class="{ 'dish-image--thumb': !!size }"
    :style="boxStyle"
  >
    <v-img
      v-if="shown"
      :src="src"
      :alt="alt"
      :aspect-ratio="ratio"
      :contain="contain"
      @error="failed = true"
    ></v-img>
    <v-responsive
      v-else
      :aspect-ratio="ratio"
      class="dish-image__empty"
    >
      <v-icon
        :size="iconSize"
        class="dish-image__icon"
      >
        {{ icons.mdiImageOffOutline }}
      </v-icon>
    </v-responsive>
  </div>
</template>

<script>
import { mdiImageOffOutline } from '@mdi/js'

export default {
  name: 'DishImage',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },

    size: { type: Number, default: 0 },
    aspectRatio: { type: Number, default: 4 / 3 },

    contain: { type: Boolean, default: false },
  },
  data: () => ({
    failed: false,
    icons: { mdiImageOffOutline },
  }),
  computed: {
    shown() {
      return !!this.src && !this.failed
    },
    ratio() {
      return this.size ? 1 : this.aspectRatio
    },
    boxStyle() {
      return this.size ? { width: `${this.size}px`, height: `${this.size}px` } : null
    },
    iconSize() {
      return this.size ? Math.round(this.size / 2) : 48
    },
  },
  watch: {
    src() {
      this.failed = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dish-image {
  overflow: hidden;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.05);

  &--thumb {
    flex: none;
    border-radius: 4px;
  }
}

.theme--dark .dish-image {
  background: rgba(255, 255, 255, 0.07);
}

.dish-image__empty ::v-deep .v-responsive__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dish-image__icon {
  opacity: 0.45;
}
</style>
